// extracted by mini-css-extract-plugin
module.exports = {"comp":"CompareSelector_comp__qHFIa"};